<template>
    <div class="release" v-show="visible">
        <div class="releaseshadow"></div>
        <div class="releasemain">
            <div class="releasebox">
                <div class="release_title">
                    <p>发布回测报告</p>
                    <span @click="close"></span>
                </div>
                <div class="release_main">
                    <div class="report_name">
                        <p>报告名称 : </p>
                        <p>{{ titletext.length === 0 ? '名称不能为空' : (titletext.length < 5 ? '名称不能少于5个字' : '') }}</p>
                        <p>（不超过15字）</p>
                        <input type="text" v-model.trim="titletext" @keyup="limitinput(1)" @blur="limitinput(0)" maxlength="15">
                    </div>
                    <div class="report_logical">
                        <p>逻辑说明 : </p>
                        <p>{{ logictext.length | limitlength }}/200</p>
                        <textarea v-model.trim="logictext" @keyup="limitarea(1)" @blur="limitarea(0)" maxlength="200"></textarea>
                    </div>
                    <div class="report_label">
                        <p>策略标签 : </p>
                        <p>示例：短线  平台突破  主力流入</p>
                        <p v-show="labelTen" class="label-tip">标签数不能超过十个</p>
                        <p v-show="labelSixteen" class="label-tip">单标签不能超过十六个字符</p>
                        <input type="text" v-model.trim="tagtext" @blur="labelDataValidation($event.target)">
                    </div>
                    <p class="save_bind_tel" v-show="issavebindtel">发布失败，您的同花顺账户暂未绑定手机号码</p>
                    <div v-if="isPublish !== 2 && isPublish !== 1" class="save_draft" @click="saveBacktest(0)" :class="backtestClass ? 'disable' : ''">保存草稿</div>
                    <div class="release_strategy" @click="saveBacktest(1)" :class="backtestClass ? 'disable' : ''">{{ isSaveLoading ? '发布中' : '发布策略'}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {labelVal} from '@/lib/formValidation.js'
    export default {
        data () {
            return {
                logictext: '',
                titletext: '',
                tagtext: '',
                isSaveLoading: false,
                backtestClass: true,
                labelTen: false,
                labelSixteen: false,
                issavebindtel: false
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            backtestId: {
                type: String,
                default: ''
            },
            isPublish: {
                type: Number,
                default: 0
            }
        },
        watch: {
            visible (val) {
                if (val) {
                    this.logictext = ''
                    this.titletext = ''
                    this.tagtext = ''
                }
            }
        },
        computed: {
            buriedPoint () {
                return this.$buriedPoint.strategyBacktest.releaseBacktestReport
            }
        },
        methods: {
            labelDataValidation (even) {
                // window.TA.log(this.buriedPoint.modifyLabel)
                let val = even.value
                switch (labelVal(val)) {
                case 1:
                    this.labelTen = true
                    this.labelSixteen = false
                    this.backtestClass = true
                    even.focus()
                    even.className = 'focus'
                    break
                case 2:
                    this.labelSixteen = true
                    this.backtestClass = true
                    even.focus()
                    even.className = 'focus'
                    break
                default:
                    this.labelTen = false
                    this.labelSixteen = false
                    // this.backtestClass = false
                    if (this.titletext.length < 5) {
                        this.backtestClass = true
                    } else {
                        this.backtestClass = false
                    }
                    even.className = ''
                }
            },
            limitinput (num) {
                // if (num === 0) {
                //     window.TA.log(this.buriedPoint.modifyName)
                // }
                if (this.titletext.length > 15) {
                    this.titletext = this.titletext.substr(0, 15)
                }
                if (this.titletext.length < 5) {
                    this.backtestClass = true
                } else {
                    this.backtestClass = false
                }
            },
            limitarea (num) {
                // if (num === 0) {
                //     window.TA.log(this.buriedPoint.modifyLogic)
                // }
                if (this.logictext.length > 200) {
                    this.logictext = this.logictext.substr(0, 200)
                }
            },
            close () {
                this.$emit('update:visible', false)
            },
            // publish: 0-保存回测 1-发布回测
            saveBacktest (publish) {
                var self = this
                if (!this.backtestClass) {
                    if (this.isSaveLoading) {
                        return
                    }
                    var requestData = {id: this.backtestId}
                    requestData['title'] = this.titletext
                    requestData['logic'] = this.logictext
                    requestData['tag'] = this.tagtext
                    if (publish === 1) {
                        window.TA.log(this.buriedPoint.saveDraft)
                        requestData['is_publish'] = 1
                        this.isSaveLoading = true
                    } else {
                        window.TA.log(this.buriedPoint.releaseStrategy)
                        requestData['is_publish'] = 2
                    }
                    axios.post('/tradebacktest/save', requestData).then((res) => {
                        self.isSaveLoading = false
                        var response = res.data
                        if (res) {
                            if (response.errorcode !== 0 && response.errorcode !== -99) {
                                self.$tip({message: response.errormsg ? response.errormsg : '操作失败', duration: 2000, type: 'error'})
                            } else if (response.errorcode === -99) {
                                self.issavebindtel = true
                            } else {
                                self.$store.dispatch('myStrategy/requestTradeBacktest')
                                self.$tip({message: publish ? '提交成功！正在审核中' : '保存成功', duration: 2000, type: 'success'})
                                self.close()
                                self.$emit('update:isPublish', requestData['is_publish'])
                            }
                        }
                    }).catch(function (error) {
                        self.isSaveLoading = false
                        self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                    })
                }
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategybacktest/release.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategybacktest/release-dialog.vue